module.exports = __webpack_public_path__ + "static/media/2.e4fbdf36.png";